exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "*{margin:0;padding:0;box-sizing:border-box}*,button,input{font-family:Roboto,sans-serif;border:0;outline:0}body,html{height:100%}:root{--primary:#36393f;--secondary:#2f3136;--tertiary:#202225;--quaternary:#292b2f;--quinary:#393d42;--senary:#828386;--white:#fff;--grey:#8a8c90;--chat-input:#40444b;--symbol:#74777a;--notification:#f84a4b;--discord:#6e86d6;--mention-detail:#f9a839;--mention-message:#413f3f;--link:#5d80d6;--rocketseat:#63c}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/styles/main.scss
// module id = 32
// module chunks = 0